import askPlanTypePage from '../components/AskPlanTypePage'
import { connect } from 'react-redux';
import { selectDesignPath, selectOnlyContactPath } from '../actions/plan'
const mapStateToProps = (state) => {
	return {
	};
}
const mapDispatchToProps = (dispatch, ownProps) => ({
	onSelectDesingPath: () => {
		dispatch(selectDesignPath());
		ownProps.nextPage();
	},
	onSelectOnlyContactPath: () => {
		dispatch(selectOnlyContactPath());
		ownProps.nextPage();
	}
})



let AskPlanTypeContainer = connect(mapStateToProps, mapDispatchToProps)(askPlanTypePage);
export default AskPlanTypeContainer;